/**
 * Order status → visual accents (Feb 2026 v10).
 *
 * Single source of truth for both admin & branch order tiles. Keeps
 * the pill palette (background + text) AND the tile's left-side
 * accent border + subtle body tint in sync.
 *
 * Palette matches the ops-brief chart:
 *   confirmed        → blue
 *   new / draft      → grey    (PENDING)
 *   assigned         → yellow  (PROCESSING)
 *   picked_up        → orange
 *   out_for_delivery → purple  (DISPATCHED)
 *   delivered        → green
 *   received         → green
 *   failed           → red
 *   cancelled        → red
 */

const ACCENTS = {
  confirmed:        { border: 'border-l-blue-400',    tint: 'bg-blue-50/50' },
  new:              { border: 'border-l-neutral-300', tint: 'bg-neutral-50/70' },
  draft:            { border: 'border-l-neutral-300', tint: 'bg-neutral-50/70' },
  assigned:         { border: 'border-l-yellow-400',  tint: 'bg-yellow-50/60' },
  picked_up:        { border: 'border-l-orange-400',  tint: 'bg-orange-50/50' },
  out_for_delivery: { border: 'border-l-purple-400',  tint: 'bg-purple-50/50' },
  delivered:        { border: 'border-l-emerald-400', tint: 'bg-emerald-50/50' },
  received:         { border: 'border-l-emerald-400', tint: 'bg-emerald-50/50' },
  failed:           { border: 'border-l-red-400',     tint: 'bg-red-50/50' },
  cancelled:        { border: 'border-l-red-400',     tint: 'bg-red-50/50' },
};

const FALLBACK = { border: 'border-l-neutral-300', tint: 'bg-neutral-50/70' };

/**
 * Return the accent classes (border-l-* + bg-*) for a given order
 * status. Consumers compose them into their tile like:
 *   <div className={`... border-l-4 ${accent.border} ${accent.tint}`}>
 * so `border-l-4` (the STROKE width) stays a caller-side decision —
 * keeps this helper unopinionated on thickness.
 */
export const getStatusAccent = (status) => ACCENTS[status] || FALLBACK;
